import React from 'react'
import { connect as connectRedux } from 'react-redux'
import { Map, List } from 'immutable'
import { getBoundActions } from '../../../actions/index'
import { getAuthIsLoggedIn } from '../../../services/auth/index'
import { isEntitled } from '../../../services/subscription/index'
import { ROLE_ID_AMBASSADOR } from '../../../services/auth-access/index'
import { TYPE_SHARE_V2_SHARE } from '../../../services/dialog/index'
import { SHARE_INITIATED_GA4_EVENT } from '../../../services/event-tracking/index'
import { SHARE_TOOLTIP_MAX_COUNT } from '../../../services/feature-tracking/constants'
import Button, { TYPES } from '../../Button/index'
import Gift from '../../Icon/icons/Gift/index'

/**
 * @param {Object} props - The props
 * @param {Map} props.detailData - The content details data
 * @param {Object} props.ga4EventData - The GA4 details data
 * @returns {JSX.Element} DetailPageV3ActionShare
 */

const DetailPageV3ActionShare = (props) => {
  const {
    detailData = Map(),
    ga4EventData,
    staticText,
    auth,
    clearShare,
    renderModal,
    setEventDefault,
    setFeatureTrackingDataPersistent,
  } = props

  const isLoggedIn = getAuthIsLoggedIn(auth)
  const geoAllowed = detailData.getIn(['featureMedia', 'contentPolicy', 'accessCheck', 'countryAllowed'])
  const isSharedAllowed = detailData.getIn(['featureMedia', 'contentPolicy', 'shareAllowed'])
  const isUserEntitled = isEntitled(auth.get('subscriptions', List()))
  const isAmbassador = auth.get('roleIds', List()).includes(ROLE_ID_AMBASSADOR)

  const canShare = isLoggedIn && geoAllowed && isSharedAllowed && (isUserEntitled || isAmbassador)

  const handleShareClick = () => {
    renderModal(TYPE_SHARE_V2_SHARE, {
      onDismiss: () => clearShare(),
      contentId: detailData.get('contentId'),
      contentUrl: detailData.get('path'),
      contentType: detailData.get('contentType'),
      parentSeriesId: detailData.get('seriesId'),
      parentSeriesName: detailData.get('seriesTitle'),
      title: detailData.get('title'),
      uiLocation: ga4EventData.ui_location,
    })

    // set max tooltip count so it will not be shown again
    setFeatureTrackingDataPersistent({
      data: Map({ shareTooltipCount: SHARE_TOOLTIP_MAX_COUNT }),
      auth,
    })

    // GA4 event
    setEventDefault(SHARE_INITIATED_GA4_EVENT.mergeDeep(ga4EventData))
  }

  if (!canShare) {
    return null
  }

  return (
    <Button
      type={TYPES.ICON}
      iconSvg={<Gift />}
      onClick={handleShareClick}
      className="detail-page-v3__action-button detail-page-v3__action-button--royal"
    >
      <span className="detail-page-v3__action-label detail-page-v3__action-label--royal">
        {staticText.get('shareFullVideo')}
      </span>
    </Button>
  )
}

export default connectRedux((state) => ({
  auth: state.auth,
  user: state.user,
  staticText: state.staticText.getIn(['data', 'detailPageV3', 'data'], Map()),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    addToasty: actions.toasty.addToasty,
    renderModal: actions.dialog.renderModal,
    clearShare: actions.share.clearShare,
    setEventDefault: actions.eventTracking.setEventDefault,
    setFeatureTrackingDataPersistent: actions.featureTracking.setFeatureTrackingDataPersistent,
  }
})(DetailPageV3ActionShare)
